/*
 * One-click subscription upgrade from the cart (snippets/nb-subscribe-upsell.liquid).
 *
 * Switches a single cart line onto a selling plan via /cart/change.js, then
 * repaints the cart with the Section Rendering API using the same section
 * ids/selectors Dawn's own cart.js uses — so the line price, the subtotal, the
 * cart bubble and the free-shipping bar all stay in sync, and the upsell card
 * removes itself because the re-rendered line now has a selling plan.
 *
 * Loaded from both sections/main-cart-items.liquid and snippets/cart-drawer.liquid,
 * hence the run-once guard.
 */
(function () {
  if (window.__nbSubUpsellBound) return;
  window.__nbSubUpsellBound = true;

  function sectionInnerHTML(html, selector) {
    var node = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return node ? node.innerHTML : null;
  }

  // Mirrors Dawn: element id to swap into, section id to request, selector to unwrap.
  function targets(inDrawer) {
    var list = [];

    if (inDrawer) {
      if (document.getElementById('CartDrawer')) {
        list.push({ id: 'CartDrawer', section: 'cart-drawer', selector: '#CartDrawer' });
      }
    } else {
      var items = document.getElementById('main-cart-items');
      var footer = document.getElementById('main-cart-footer');
      if (items) list.push({ id: 'main-cart-items', section: items.dataset.id, selector: '.js-contents' });
      if (footer) list.push({ id: 'main-cart-footer', section: footer.dataset.id, selector: '.js-contents' });
      if (document.getElementById('cart-live-region-text')) {
        list.push({ id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' });
      }
    }

    if (document.getElementById('cart-icon-bubble')) {
      list.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    }

    return list.filter(function (t) {
      return t.section;
    });
  }

  function changeUrl() {
    if (window.routes && window.routes.cart_change_url) return window.routes.cart_change_url;
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return root + 'cart/change.js';
  }

  function fail(button, message) {
    var box = button.parentElement.querySelector('[data-nb-sub-error]');
    if (box) {
      box.textContent = message;
      box.hidden = false;
    }
  }

  function upgrade(button) {
    if (button.getAttribute('aria-busy') === 'true') return;

    var errorBox = button.parentElement.querySelector('[data-nb-sub-error]');
    if (errorBox) errorBox.hidden = true;

    button.setAttribute('aria-busy', 'true');
    button.classList.add('is-loading');

    var inDrawer = !!button.closest('#CartDrawer');
    var toRender = targets(inDrawer);

    /* credentials matters here. fetch only defaults to sending cookies on
       same-origin requests in browsers that implement the 2017 default, and a
       browser set to block cookies drops them anyway. Without the cart cookie
       Shopify answers on a DIFFERENT, empty cart and still returns HTTP 200, so
       nothing throws, nothing renders differently, and the button looks dead.
       That is the "works for me, does nothing for her" report. The other cart
       scripts here already pass this; this one did not. */
    fetch(changeUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: button.dataset.key,
        quantity: parseInt(button.dataset.quantity, 10),
        selling_plan: parseInt(button.dataset.sellingPlan, 10),
        sections: toRender.map(function (t) {
          return t.section;
        }),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        return response.json().then(function (body) {
          return { ok: response.ok, body: body };
        });
      })
      .then(function (result) {
        // Shopify reports cart errors with a 4xx plus a `description`.
        if (!result.ok || result.body.status) {
          throw new Error(result.body.description || result.body.message || 'Could not update the cart.');
        }

        var state = result.body;

        /* A 200 is not proof the upgrade happened. If the line did not come back
           carrying a selling plan, say so instead of repainting an unchanged cart
           and leaving the shopper to wonder whether the click registered. */
        var line = null;
        for (var i = 0; i < (state.items || []).length; i++) {
          if (state.items[i].key === button.dataset.key) line = state.items[i];
        }
        if (!line || !line.selling_plan_allocation) {
          throw new Error('Could not switch this to a subscription. Please refresh and try again.');
        }

        // Empty-cart flags, same as Dawn does after a quantity change.
        var drawerWrapper = document.querySelector('cart-drawer');
        var footer = document.getElementById('main-cart-footer');
        if (footer) footer.classList.toggle('is-empty', state.item_count === 0);
        if (drawerWrapper) drawerWrapper.classList.toggle('is-empty', state.item_count === 0);

        toRender.forEach(function (t) {
          var root = document.getElementById(t.id);
          if (!root || !state.sections || !state.sections[t.section]) return;
          var html = sectionInnerHTML(state.sections[t.section], t.selector);
          if (html === null) return;
          var swapInto = root.querySelector(t.selector) || root;
          swapInto.innerHTML = html;
        });

        document.dispatchEvent(new CustomEvent('nb:subscription-upgraded', { detail: { cart: state } }));
      })
      .catch(function (error) {
        button.setAttribute('aria-busy', 'false');
        button.classList.remove('is-loading');
        fail(button, error.message || 'Could not update the cart. Please try again.');
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-nb-sub-upgrade]');
    if (!button) return;
    event.preventDefault();
    upgrade(button);
  });
})();
